import React from 'react';
import { motion } from 'framer-motion';
import './index.scss';

interface Tech {
  name: string;
  icon: string;
  level: number;
}

interface TechCategory {
  name: string;
  icon: string;
  techs: Tech[];
}

const TechStack: React.FC = () => {
  const techCategories: TechCategory[] = [
    {
      name: '前端技术',
      icon: '🖥️',
      techs: [
        { name: 'React', icon: '⚛️', level: 85 },
        { name: 'TypeScript', icon: 'TS', level: 80 },
        { name: 'JavaScript', icon: 'JS', level: 85 },
        { name: 'HTML/CSS', icon: '🌐', level: 90 },
        { name: 'Sass', icon: 'Sass', level: 20 },
        { name: 'Webpack', icon: 'W', level: 30 },
        { name: 'Node.js', icon: '🟢', level: 85 },
      ]
    },
    {
      name: '后端技术',
      icon: '⚙️',
      techs: [
        { name: 'Java', icon: '☕', level: 95 },
        { name: 'Spring Boot', icon: 'SB', level: 95 },
        
        { name: 'Git', icon: 'Git', level: 50 },
      ]
    },
    {
      name: '数据库',
      icon: '💾',
      techs: [
        { name: 'MySQL', icon: 'MySQL', level: 85 },
        { name: 'Oracle', icon: 'Oracle', level: 80 },
        { name: 'Redis', icon: 'Redis', level: 85 },
        { name: 'TDSQL', icon: 'TDSQL', level: 80 },
        { name: 'GAUSSDB', icon: 'GAUSSDB', level: 80 },
      ]
    }
  ];

  return (
    <section className="tech-stack">
      <div className="container">
        <div className="section-header">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            技术栈
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            我熟悉的技术和工具
          </motion.p>
        </div>

        {techCategories.map((category, categoryIndex) => (
          <motion.div 
            key={category.name}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: categoryIndex * 0.2 }}
            viewport={{ once: true }}
            className="tech-category"
          >
            <div className="category-header">
              <span className="category-icon">{category.icon}</span>
              <h3 className="category-name">{category.name}</h3>
            </div>
            <div className="tech-grid">
              {category.techs.map((tech, techIndex) => (
                <motion.div
                  key={tech.name}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: categoryIndex * 0.2 + techIndex * 0.1 }}
                  viewport={{ once: true }}
                  whileHover={{ y: -10, boxShadow: '0 20px 40px rgba(66, 153, 225, 0.2)' }}
                  className="tech-card"
                >
                  <div className="tech-icon">{tech.icon}</div>
                  <h3 className="tech-name">{tech.name}</h3>
                  <div className="tech-level">
                    <div className="level-bar">
                      <motion.div 
                        className="level-fill"
                        initial={{ width: 0 }}
                        whileInView={{ width: `${tech.level}%` }}
                        transition={{ duration: 1, delay: categoryIndex * 0.2 + techIndex * 0.1 + 0.3 }}
                        viewport={{ once: true }}
                      ></motion.div>
                    </div>
                    <span className="level-text">{tech.level}%</span>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default TechStack;